import { motion } from 'framer-motion';

interface Props {
  current: number;
  total: number;
  questionLabel?: string;
  ofLabel?: string;
  completeLabel?: string;
}

export function ProgressBar({ current, total, questionLabel = 'Question', ofLabel = 'of', completeLabel = 'Complete' }: Props) {
  const percentage = (current / total) * 100;

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-3">
        <span className="freud-label text-chocolate-600">
          {questionLabel} {current} {ofLabel} {total}
        </span>
        <span className="freud-label text-sage-600">
          {Math.round(percentage)}% {completeLabel}
        </span>
      </div>
      <div className="bg-cream-200 rounded-full h-3 overflow-hidden shadow-inner">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="h-full bg-gradient-to-r from-sage-400 via-sage-500 to-coral-500 rounded-full"
        />
      </div>
    </div>
  );
}